'use client';

import { useEffect, useLayoutEffect, useState } from 'react';

const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

/**
 * @param {{
 *  children?:import('react').ReactNode;
 *  defer?:boolean;
 *  fallback?:import('react').ReactNode
 * }} props
 */
const NoSsr = props => {
  const { children, defer = false, fallback = null } = props;
  const [mountedState, setMountedState] = useState(false);

  useEnhancedEffect(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);

  useEffect(() => {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]);

  return mountedState ? children : fallback;
};

export default NoSsr;
